export const getBasketTotal = (basket) => {
  return basket?.reduce((amount, item) => {
    return amount + item.price;

  }, 0);
};
export const initialState = {
  user: null,
  basket: [],
};
export default function AppReducer(state = initialState, action) {
  
  const index = state.basket.findIndex(
    (basketItem) => basketItem.id === action.id
  );
  let newBasket = [...state.basket];

  
  if (index >= 0) {
    newBasket.splice(index, 1);
  }else {
    console.warn(
      `can't remove product {id ${action.id} as it's not in basket}`
    )
  }
  
  switch (action.type) {
    case "SET_USER":
      return {
        ...state,
        user: action.user,
      };
    case "ADD_TO_BASKET":
      return {
        ...state,
        basket: [...state.basket, action.item],
      };
    case "REMOVE_FROM_BASKET":
      return {
        ...state,
        basket: newBasket,
      };
      case "EMPTY_BASKET":
        return {
          ...state,
          basket: [],
        }
    default:
      return state;
  }
}
